__turbopack_context__.v({
  "actions": "SaveTripToastContent-module__YWR-1W__actions",
  "copy": "SaveTripToastContent-module__YWR-1W__copy",
  "emailButton": "SaveTripToastContent-module__YWR-1W__emailButton",
  "prompt": "SaveTripToastContent-module__YWR-1W__prompt",
  "subtitle": "SaveTripToastContent-module__YWR-1W__subtitle",
  "title": "SaveTripToastContent-module__YWR-1W__title",
});
